module.exports = __webpack_public_path__ + "static/media/main-promo-4.0b8c1dd2.jpg";